import { __assign, __awaiter, __generator, __values } from "tslib";
import { OfficeActionId, } from '@office-start/action-types';
import { ActionContextMenuItemIcon, } from '@office-start/document-types';
import { format } from '@office-start/string-formatter-utility';
/**
 * Helper function to convert {@link OfficeAction} to {@link DocumentAction}
 */
var createDocumentAction = function (action, executeAction, title, fileType, disabled, tooltipString) {
    var _a;
    return {
        ariaLabel: title,
        contentActionOptions: {
            badgeText: action.metadata.badgeText,
            groupId: action.metadata.groupId,
            icon: ((_a = action.metadata.icon) === null || _a === void 0 ? void 0 : _a.type) == ActionContextMenuItemIcon.Brand &&
                fileType != undefined
                ? {
                    type: action.metadata.icon.type,
                    fileType: fileType,
                }
                : action.metadata.icon,
        },
        executeAction: executeAction,
        id: "".concat(action.metadata.appId, "_").concat(action.metadata.id),
        title: title,
        disabled: disabled,
        tooltipString: tooltipString,
    };
};
var getDocumentActionOrUndefined = function (action, actionExecutor, content, telemetryConfig, targetUX, shareUIPositionOverride) {
    var actionToExecute = action.officeActionCreator(content, targetUX, shareUIPositionOverride);
    // If this action is not applicable for this piece of content, skip it...
    if (!actionToExecute) {
        return undefined;
    }
    // Convert to document action to be used in the rest of the application UX
    return createDocumentAction(action, function (_action, sourceUXComponent) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, actionExecutor.executeActionAsync(actionToExecute, __assign(__assign({}, telemetryConfig), { actionId: action.metadata.id, appId: action.metadata.appId, sourceUXComponent: sourceUXComponent || telemetryConfig.sourceUXComponent, referral: actionToExecute.payload.referral || undefined, referralPlatform: actionToExecute.payload.referralPlatform || undefined }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, action.metadata.id == OfficeActionId.OpenInApp
        ? format(action.metadata.name, content.app)
        : action.metadata.name, content.fileType, actionToExecute.payload.disabled, actionToExecute.payload.tooltipString);
};
export var buildDocumentActions = function (contentActions, actionExecutor, document, telemetryConfig, targetUX, shareUIPositionOverride) {
    var e_1, _a;
    var documentActions = [];
    try {
        for (var contentActions_1 = __values(contentActions), contentActions_1_1 = contentActions_1.next(); !contentActions_1_1.done; contentActions_1_1 = contentActions_1.next()) {
            var action = contentActions_1_1.value;
            var documentAction = getDocumentActionOrUndefined(action, actionExecutor, document, telemetryConfig, targetUX, shareUIPositionOverride);
            if (!documentAction) {
                continue;
            }
            documentActions.push(documentAction);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (contentActions_1_1 && !contentActions_1_1.done && (_a = contentActions_1.return)) _a.call(contentActions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return documentActions;
};
//# sourceMappingURL=documentActionBuilder.js.map